import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';

import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

import {
  openrtbMediaRtbStatistics,
  openRtbsetOnOffMedia,
  openRtbSetting,
  openRtbWeightGet,
  openrtbOfftatistics,
  openrtbMediaHistory,
} from 'lib/api/openrtb';
import {
  makeRowColumn,
  getHeadObj,
  converParameters,
  under2camel,
  conversionParams,
  getHost,
} from 'lib/commonLib';
import { paramConverter } from 'modules/common';
import { setPortal } from 'modules/portal';

import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import Dialog from 'components/organisms/Dialog';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

import OpenRTBCategoryListBox from './OpenRTBCategoryListBox';
import OpenRTBSizeListBox from './OpenRTBSizeListBox';
import Modal from './Modal';

const useStyles = makeStyles((theme) => ({
  stateBox: {
    padding: '5px 10px',
    borderRadius: 5,
    color: theme.palette.common.white,
  },
  controllerIcon: { width: 35, height: 35 },
}));

const OpenRTBMediaRtbStatistics = (props) => {
  const { handleClickSnackbar, location } = props;
  const locationSearch = queryString.parse(location.search);

  const theme = useTheme();
  const classes = useStyles();
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const { portal, common, allProductCodeList } = useSelector(
    ({ common, portal }) => ({
      allProductCodeList: common.allProductCodeList,
      portal: portal,
      common: common,
    })
  );

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  let initParams = {
    order: 'ADVRTS_AMT',
    sort: 'desc',
    ctgrSeq: 'all',
    sizeVal: 'all',
    itlTpCode: '04',
    pltfomTpCode: 'all',
    stateFlag: '01',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
    uri: '/manage/openrtb/media_rtb',
  };
  const converParams = conversionParams(
    common.productCodeList,
    locationSearch,
    allProductCodeList
  );
  initParams = { ...initParams, ...converParams };
  const [params, setParams] = useState(initParams);
  const [tempParams, setTempParams] = useState(initParams);
  const isStateOn = params['stateFlag'] === '01';

  const initDialog = { open: false, sectionText: '' };
  const initModal = {
    open: false,
    type: null,
    params: {},
    data: [],
    headerTitle: '',
  };
  const initCustomized = {
    SITE_NAME: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'SITE_NAME');
        const bodyItem2 = getHeadObj(headsMap, 'MEDIA_SCRIPT_NO');
        return rowObj['FIXED'] === 0
          ? makeRowColumn(rowObj['SITE_NAME'], bodyItem1.type, bodyItem1.format)
          : makeRowColumn(
              rowObj['SITE_NAME'],
              bodyItem1.type,
              bodyItem1.format
            ) +
              '(' +
              makeRowColumn(
                rowObj['MEDIA_SCRIPT_NO'],
                bodyItem2.type,
                bodyItem2.format
              ) +
              ')';
      },
      orderFlag: false,
    },
    MEDIA_SCRIPT_NO: { merged: !isStateOn, orderFlag: false },
    PLTFOM_TP_NAME: { merged: true },
    MEDIA_SCRIPT_CNT: { orderFlag: false },
    BID_REQ_CNT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'BID_REQ_CNT');
        const bodyItem2 = getHeadObj(headsMap, 'BID_CNT');
        const bodyItem3 = getHeadObj(headsMap, 'BID_RATE');
        return (
          <>
            {makeRowColumn(
              rowObj['BID_REQ_CNT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <br />
            {makeRowColumn(rowObj['BID_CNT'], bodyItem2.type, bodyItem2.format)}
            <br />
            {makeRowColumn(
              rowObj['BID_RATE'],
              bodyItem3.type,
              bodyItem3.format
            )}
          </>
        );
      },
    },
    BID_CNT: { merged: true },
    BID_RATE: { merged: true },
    BID_ECPM: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'BID_ECPM');
        const bodyItem2 = getHeadObj(headsMap, 'WIN_BID_ECPM');
        const bodyItem3 = getHeadObj(headsMap, 'ECPM');
        return (
          <>
            {makeRowColumn(
              rowObj['BID_ECPM'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <br />
            {makeRowColumn(
              rowObj['WIN_BID_ECPM'],
              bodyItem2.type,
              bodyItem2.format
            )}
            <br />
            {makeRowColumn(rowObj['ECPM'], bodyItem3.type, bodyItem3.format)}
          </>
        );
      },
    },
    WIN_BID_ECPM: { merged: true },
    ECPM: { merged: true },
    STATE: {
      makeBody: (rowObj, headsMap) => {
        const stateOn = rowObj['STATE'] === '01';
        return (
          rowObj['FIXED'] !== 0 && (
            <div
              className={classes.stateBox}
              style={{
                backgroundColor: stateOn
                  ? theme.palette.common.green
                  : theme.palette.common.red,
              }}
            >
              {stateOn ? 'ON' : 'OFF'}
            </div>
          )
        );
      },
    },
  };

  const [initialization, setInitialization] = useState(false);
  const [customized, setCustomized] = useState(initCustomized);
  const [dialog, setDialog] = useState(initDialog);
  const [modal, setModal] = useState(initModal);
  const [reFetch, setReFetch] = useState(false);
  const [weightList, setWeightList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [popupLoading, setPopupLoading] = useState(false);

  useEffect(() => {
    handleCustom(initParams);
    openRtbWeightGet()
      .then((response) => {
        const { data } = response.data;
        setWeightList(data);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .then(() => {
        setLoading(false);
      }); // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  const handleOnReset = () => {
    if (isStateOn) {
      if (
        JSON.stringify(params) !== JSON.stringify(initParams) ||
        JSON.stringify(tempParams) !== JSON.stringify(initParams)
      ) {
        setInitialization(true);
        setParams(initParams);
        setTempParams(initParams);
      }
    } else {
      let tempInit = { ...initParams, stateFlag: '02' };
      delete tempInit['sDate'];
      delete tempInit['eDate'];
      delete tempInit['advrtsPrdtCode'];
      delete tempInit['advrtsTpCode'];
      if (
        JSON.stringify(params) !== JSON.stringify(initParams) ||
        JSON.stringify(tempParams) !== JSON.stringify(initParams)
      ) {
        setInitialization(true);
        setParams(tempInit);
        setTempParams(tempInit);
      }
    }
  };

  const handleCustom = (propsParams) => {
    let tempCustom = { ...customized };
    tempCustom = {
      ...tempCustom,
      MANAGE_ICONS: {
        makeBody: (rowObj, headsMap) => {
          let result;
          const isCustomStateFlag = propsParams['stateFlag'] === '01';
          const detailUrl = converParameters({
            url: getHost('new') + '/manage/openrtb/mediaRtbDetail',
            sDate: propsParams['sDate'],
            eDate: propsParams['eDate'],
            itlTpCode: propsParams['itlTpCode'],
            mediaScrtHirnkNo: rowObj['MEDIA_SCRIPT_NO'],
            isPop: 1,
          });
          const adverDetailUrl = converParameters({
            url: getHost('new') + '/report/adver/statistics',
            sDate: propsParams['sDate'],
            eDate: propsParams['eDate'],
            itlTpCode: propsParams['itlTpCode'],
            mediaScriptNo: rowObj['MEDIA_SCRIPT_NO'],
            advrtsPrdtCode: propsParams['advrtsPrdtCode'],
            advrtsTpCode: propsParams['advrtsTpCode'],
            pltfomTpCode: propsParams['pltfomTpCode'],
            isPop: 1,
          });

          if (isCustomStateFlag) {
            result = rowObj['FIXED'] !== 0 && (
              <TableBtnWrap>
                <NewButton
                  title={t('지면 상세보기')}
                  iconBtn
                  icon="faFileSearch"
                  disableRipple
                  onClick={(e) => handlePortalUrl(detailUrl)}
                />
                <NewButton
                  title={t('해당매체의 광고주별통계 팝업')}
                  iconBtn
                  icon="faExternalLink"
                  disableRipple
                  onClick={(e) => handlePortalUrl(adverDetailUrl)}
                />
              </TableBtnWrap>
            );
          } else {
            result = (
              <TableBtnWrap>
                <NewButton
                  title={t('RTB 지면 이력 확인')}
                  iconBtn
                  icon="faFileSearch"
                  disableRipple
                  onClick={(e) => handleModalOpen(rowObj)}
                />
              </TableBtnWrap>
            );
          }

          return result;
        },
      },
      IMAGE_SIZE_NAME: {
        makeBody: (rowObj, headsMap) => {
          let result;
          const bodyItem1 = getHeadObj(headsMap, 'IMAGE_SIZE_NAME');
          if (propsParams['stateFlag'] === '01') {
            result =
              rowObj['FIXED'] !== 0 &&
              makeRowColumn(
                rowObj['IMAGE_SIZE_NAME'],
                bodyItem1.type,
                bodyItem1.format
              );
          } else {
            result = makeRowColumn(
              rowObj['IMAGE_SIZE_NAME'],
              bodyItem1.type,
              bodyItem1.format
            );
          }
          return result;
        },
      },
    };
    setCustomized(tempCustom);
  };

  const getTempParam = (newParams, name) => {
    if (JSON.stringify(tempParams) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
    }
  };

  const getParam = () => {
    if (JSON.stringify(tempParams) !== JSON.stringify(params)) {
      let newParams = { ...tempParams };
      if (newParams['stateFlag'] !== params['stateFlag']) {
        if (newParams['stateFlag'] === '02') {
          newParams = {
            ...newParams,
            uri: '/manage/openrtb/media_off',
            order: 'OFF_REG_DATE',
            sort: 'desc',
          };
          delete newParams['sDate'];
          delete newParams['eDate'];
          delete newParams['advrtsPrdtCode'];
          delete newParams['advrtsTpCode'];
        } else {
          newParams = {
            ...newParams,
            order: initParams['order'],
            sort: initParams['sort'],
            sDate: initParams['sDate'],
            eDate: initParams['eDate'],
            advrtsPrdtCode: initParams['advrtsPrdtCode'],
            advrtsTpCode: initParams['advrtsTpCode'],
            uri: '/manage/openrtb/media_rtb',
          };
        }
        setTempParams(newParams);
      }
      setParams(newParams);
      handleCustom(newParams);
    }
  };

  const getTableParam = (newParams, name) => {
    let tempParams = { ...params };
    let tempNewParams = { ...newParams };
    delete tempParams['stateFlag'];
    delete tempNewParams['stateFlag'];
    if (JSON.stringify(tempParams) !== JSON.stringify(tempNewParams)) {
      let newData = { ...tempNewParams, stateFlag: params['stateFlag'] };
      setParams(newData);
      handleCustom(newData);
    }
  };

  const headCallBack = (type, data) => {
    let tmpExlNo = [];
    data.forEach(function (rowData) {
      tmpExlNo.push(rowData['MEDIA_SCRIPT_NO']);
    });
    let newModal = { ...initModal, open: true, type: type, params: {} };
    let newParams = {
      mediaScriptNo: String(tmpExlNo),
      cpcFlag: '01',
      cpmFlag: '02',
      bidUprcFlag: '02',
      sendNumFlag: '02',
    };
    if (type === 'edit') {
      newModal['headerTitle'] = t('가중치 설정');
      for (let targetCode of weightList) {
        if (!!targetCode) {
          const codeInfo = allProductCodeList.find(
            (element) => element['value'] === targetCode
          );
          if (
            codeInfo['codeVal'] === 'CW' ||
            codeInfo['codeVal'] === 'PF' ||
            codeInfo['codeVal'] === 'TC'
          ) {
            newParams[under2camel(codeInfo['codeVal'] + '_cpc_send')] = '02';
          } else {
            newParams[under2camel(codeInfo['codeVal'] + '_cpc_send')] = '01';
          }
          newParams[under2camel(codeInfo['codeVal'] + '_cpc_weight')] = '100';
          newParams[under2camel(codeInfo['codeVal'] + '_cpm_weight')] = '100';
        }
      }
      newParams['bidUprc'] = '0';
      newParams['advrtsSendNum'] = '0';
      setModal({ ...newModal, type: 'multiModify', params: newParams });
    } else if (type === 'start') {
      setDialog({
        ...initDialog,
        open: true,
        type: type,
        params: { mediaScriptNo: String(tmpExlNo) },
        sectionText: t('선택한 지면을 활성화 하시겠습니까?'),
      });
    } else if (type === 'stop') {
      setDialog({
        ...initDialog,
        open: true,
        type: type,
        params: { mediaScriptNo: String(tmpExlNo) },
        sectionText: t('선택한 지면을 중지 하시겠습니까?'),
      });
    }
  };

  const handleDialogClose = () => {
    setDialog(initDialog);
  };

  const handleDialogSubmit = () => {
    let newState = '';
    if (dialog['type'] === 'start') {
      newState = '01';
    } else if (dialog['type'] === 'stop') {
      newState = '02';
    }
    openRtbsetOnOffMedia({
      mediaNo: dialog['params']['mediaScriptNo'],
      state: newState,
    })
      .then((response) => {
        const { message } = response.data;
        handleClickSnackbar({ message: message, option: { type: 'success' } });
        setReFetch(true);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .then(() => {
        setDialog(initDialog);
        setReFetch(false);
      });
  };

  const handleSubmit = (newParams) => {
    let tempParams = { ...newParams };
    const { params } = modal;
    if (modal['type'] === 'multiModify' || modal['type'] === 'edit') {
      if (params['cpcFlag'] === '02') {
        delete tempParams['setCpcWeightStr'];
      }
      if (params['cpmFlag'] === '02') {
        delete tempParams['setCpmWeightStr'];
      }
      if (params['bidUprcFlag'] === '02') {
        delete tempParams['bidUprc'];
      }
      if (params['sendNumFlag'] === '02') {
        delete tempParams['advrtsSendNum'];
      }
      delete tempParams['siteName'];
      delete tempParams['siteDesc'];
      if (
        tempParams['setCpcWeightStr'] === undefined &&
        tempParams['setCpmWeightStr'] === undefined &&
        tempParams['bidUprc'] === undefined &&
        tempParams['advrtsSendNum'] === undefined
      ) {
        handleClickSnackbar({
          message: t('선택된 수정사항이 없습니다.'),
          option: { type: 'error' },
        });
      } else {
        setPopupLoading(true);
        openRtbSetting(paramConverter(tempParams))
          .then((response) => {
            const { message } = response.data;
            handleClickSnackbar({
              message: message,
              option: { type: 'success' },
            });
            setReFetch(true);
          })
          .catch((error) => {
            handleClickSnackbar({ message: error, option: { type: 'error' } });
          })
          .then(() => {
            setModal(initModal);
            setReFetch(false);
          })
          .finally(() => {
            setPopupLoading(false);
          });
      }
    }
  };

  const handleModalOpen = (rowObj) => {
    let newModal = {
      ...initModal,
      open: true,
      params: { mediaScriptNo: rowObj['MEDIA_SCRIPT_NO'] },
      type: 'mediaHistory',
      headerTitle: t('RTB 지면 이력 확인'),
    };
    openrtbMediaHistory({
      mediaScriptNo: rowObj['MEDIA_SCRIPT_NO'],
      itlTpCode: params['itlTpCode'],
    })
      .then((response) => {
        const { data } = response.data;
        newModal = { ...newModal, data: data };
        setModal(newModal);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .then(() => {
        // setReFetch(false);
      });
  };

  const getModalParams = (newParams) => {
    if (JSON.stringify(modal.params) !== JSON.stringify(newParams)) {
      setModal({ ...modal, params: newParams });
    }
  };

  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (rowObj) => {
        return 'MANAGE_ICONS';
      },
    });
    return result;
  })();

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <FilterCollection
          label={t('상태')}
          name="stateFlag"
          params={tempParams}
          value={tempParams['stateFlag']}
          type="radio"
          list={[
            { label: 'ON', value: '01' },
            { label: 'OFF', value: '02' },
          ]}
          callBack={getTempParam}
          labelKey="label"
          valueKey="value"
        />
        <NewCommonFilter
          initialization={initialization}
          params={tempParams}
          getParam={getTempParam}
          externalType="select"
          pltfomTpCodeDetailFilter={['04']}
          useDisplayFilter={isStateOn}
          useDate={isStateOn}
        />
        <OpenRTBSizeListBox params={tempParams} getParams={getTempParam} />
        <OpenRTBCategoryListBox params={tempParams} getParams={getTempParam} />
        <NewButton onClick={getParam}>{t('검색')}</NewButton>
      </NewFilterWrap>
      <NewTableContainer
        params={{ ...params }}
        dataReqPromise={
          isStateOn ? openrtbMediaRtbStatistics : openrtbOfftatistics
        }
        getParam={getTableParam}
        customized={customized}
        useCheckBox
        useTotal={isStateOn}
        isIncludingTotal={isStateOn}
        headCallBack={headCallBack}
        hasActController={{ edit: isStateOn, start: true, stop: true }}
        reFetch={reFetch}
        reFetchHead
        loading={loading}
        addColumnList={addColumnList}
      />
      {modal['open'] && (
        <Modal
          modal={modal}
          getParam={getModalParams}
          handleSubmit={handleSubmit}
          handleModalClose={(f) => setModal(initModal)}
          handleClickSnackbar={handleClickSnackbar}
          weightList={weightList}
          popupLoading={popupLoading}
        />
      )}
      <Dialog
        dialog={dialog}
        handleClose={handleDialogClose}
        handleSubmit={handleDialogSubmit}
      />
    </>
  );
};

export default withRouter(OpenRTBMediaRtbStatistics);
